const preScanDE = {
    "form": {
        "modal": {
            "preScanResults": {
                "header": "Vor-Scan Ergebnisse",
                "body": {
                    "description": "Folgende Ergebnisse wurden nach der Durchführung des Scans für diese Veröffentlichung gefunden. Bitte überprüfen Sie diese in allen Einzelheiten:",
                    "table": {
                        "column": {
                            "trackName": "Titelname",
                            "type": "Typ",
                            "title": "Titel",
                            "artists": "Künstler",
                            "album": "Album",
                            "label": "Verlag",
                            "releaseDate": "Veröffentlichungsdatum",
                            "score": "Wertung (%)"
                        },
                    },
                    "label": {
                        "flaggedTracks": "Markierte Titel",
                        "music": "Musik",
                        "cover": "Cover",
                        "signDeclaration": "Bitte unterzeichnen Sie die Erklärung, um fortzufahren.",
                        "cancelRelease": "Ich möchte diese Veröffentlichung stornieren.",
                        "approveRelease": {
                            "point1": "Ich möchte diese Veröffentlichung genehmigen, weil die angezeigten Ergebnisse 100% identisch mit meiner eigenen Veröffentlichung / von einem vorherigen Verteiler übertragen sind.",
                            "point2": "Ich erkläre hierbei unter Gewährleistung der Wahrheit, dass alle Inhalte, die ich bereitstelle, meinem Unternehmen oder mir gehören, oder dass ich volle und gültige Rechte und Lizenzen besitze, die für ihre Verwendung, Verteilung und Einreichung erforderlich sind.",
                            "point3": "Ich erkennen an und akzeptiere, dass ich allein für alle rechtlichen Konsequenzen haftbar bin, die sich aus der Einreichung solcher Inhalte ergeben, einschließlich aber nicht beschränkt auf rechtliche Verfahren, Ansprüche, Kosten und Gebühren.",
                            "point4": "Ich verstehe und stimme zu, dass meine persönlichen Daten, einschließlich KYC-Informationen und anderer relevanter Daten, mit autorisierten Partnern, digitalen Service-Anbietern (DSPs), Drittanbietern, die an der Verarbeitung solcher Inhalte beteiligt sind, sowie Gerichten, Aufsichtsbehörden und Rechtsmittelbehörden geteilt werden können, im Falle eines Anspruchs, Streits oder rechtlicher Anforderungen.",
                            "point5": "Ich verstehe und stimme zu, dass Music Linkdas Recht hat, mein Vertrag unverzüglich ohne Entschädigung oder weitere Verpflichtungen zu kündigen, wenn es nachgewiesen wird, dass ich dieses Formular missbraucht habe oder wenn irgendein Teil meiner Erklärung falsch, irreführend oder irreführend ist.",
                        },
                        "noFlaggedTracks": "Keine markierten Titel im Vor-Scan gefunden, Sie können mit den nächsten Schritten fortfahren!"
                    },
                    "help_text": {
                    },
                },
                "button": {
                    "submit": "Einreichen",
                    "close": "Schließen"
                }
            },
            "performScan": {
                "header": "Vor-Scan durchführen",
                "body": "Bitte bestätigen Sie, dass Sie den Vor-Scan für diese Veröffentlichung durchführen möchten.",
                "button": {
                    "cancel": "Abbrechen",
                    "performScan": "Vor-Scan durchführen"
                }
            }
        },
        "message": {
            "releaseDistributionCancelled": "Sie haben die Verteilung der Veröffentlichung storniert, daher wurde sie heruntergesetzt.",
            "admin_pending": "Ihre Erklärung wartet auf die Überprüfung durch den Administrator für weitere Maßnahmen.",
            "admin_approved": "Ihr Antrag auf Verteilung Ihrer Veröffentlichung wurde von unserem Administratorenteam genehmigt. Die Veröffentlichung wurde erfolgreich verifiziert. Wir schätzen Ihre Sorgfalt bei der Sicherstellung von Genauigkeit und Compliance. Die Veröffentlichung wird wie geplant in allen Stores fortgesetzt. Vielen Dank für Ihre Aufmerksamkeit für Details und die Einhaltung unserer Standards.",
            "admin_rejected": "Ihr Antrag auf Verteilung Ihrer Veröffentlichung wurde abgelehnt. Nach sorgfältiger Prüfung erfüllt der Antrag nicht unsere Genehmigungsanforderungen. Wir empfehlen, den Inhalt neu zu bewerten und sicherzustellen, dass alle Bedingungen und rechtlichen Implikationen berücksichtigt werden. Vielen Dank für Ihr Verständnis und Ihre Kooperation.",
            "scanInProgress": "Scan läuft, bitte warten Sie, bis der Scan abgeschlossen ist.",
            "releaseMustBeReady": "Veröffentlichung muss in Ready-Status sein, um den Vor-Scan durchzuführen.",
            "errorSubmittingDeclaration": "Fehler aufgetreten beim Einreichen der Administrator-Vor-Scan-Erklärung.",
        }
    }
};

export default preScanDE;